// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

import { useLayoutEffect } from 'react';

export default useLayoutEffect;
